export enum ApplicationStatuses
{
    Started = "Started",
    Submitted = "Submitted",
    NotApplied = "NotApplied"
}

export enum EmploymentTypes
{
    FullTime = "Full Time",
    PartTime = "Part Time"
}

export enum DistrictColumns
{
    ApplicationStatus = "ApplicationStatus",
    City = "City",
    Deadline = "Deadline",
    Details = "Details",
    EmploymentType = "EmploymentType",
    Favorited = "Favorited",
    JobCategory = "JobCategory",
    JobPostingID = "JobPostingID",
    JobTitle = "JobTitle",
    JobType = "JobType",
    Location = "Location",
    Pay = "Pay",
    PostedDate = "PostedDate",
    StartDate = "StartDate",
    ZIPCode = "ZIPCode"
}

export interface JobPosting
{
    JobPostingID: number;
    JobTitle: string;
    BuildingCodes: string;
    EmploymentType: EmploymentTypes;
    JobType: JobType;
    JobCategory: JobCategory;
    ApplicationStatus: ApplicationStatuses;
    IsFeatured: boolean;
    PayDisplayString: string;
    PositionStartDate: string;
    Summary: string;
    ExternalAttachmentCount: number;
    ApplicantPostedDate: string;
    ApplicantDeadline: string;
    AcceptingInternalApplicationsStartDate: string;
    AcceptingInternalApplicationsEndDate: string;
    DistrictID: number;
    IsFavoriteJobPosting: boolean;
    Cities: string;
    ZipCodes: string;
}

export interface JobType
{
    Description: string;
}

export interface JobCategory
{
    Description: string;
}

export interface JobPostingState
{
    locations: string[];
    jobCategories: string[];
    employmentTypes: string[];
    cities: string[];
    zipCodes: string[];
    jobTypeDescriptions: string[];
    sorts: { [key: string]: boolean };
    // this 'keyof JobPosting' simply indicates/suggests it's a property on the JobPosting object (may be a dotted path kinda thing)
    detailFieldPathsByDisplayString: { [key: string]: keyof JobPosting };
    jobTitleSearchValue: string;
    selectedLocations: string[];
    selectedJobCategories: string[];
    selectedEmploymentTypes: string[];
    selectedCities: string[];
    selectedZipCodes: string[];
    selectedJobTypeDescriptions: string[];
    applicantInternalDistrictIDs: number[];
    orderedDistrictColumns: DistrictColumns[];
    applicantID: number;
    isPreview: boolean;
}

export interface JobPostingStore
{
    dataSource: JobPostingState;
}
